import { ChainId } from 'types';

// Chains the frontend treats as "dev networks": no Venus API, no centralized
// pool registry, no public-RPC fallback. Reads route through the on-chain
// `getLocalPools` / `getLocalLegacyPoolVTokenBalances` paths and writes can
// hit the mock-token faucet (`useFundLocalAccount`). Keep this in sync with
// the `isDevNetwork` predicate in `config/index.ts` (which takes the `Network`
// env string rather than a chainId).
export const DEV_CHAIN_IDS: readonly ChainId[] = [ChainId.LOCAL, ChainId.BITTENSOR_TESTNET];

export const isDevChainId = (chainId: ChainId): boolean => DEV_CHAIN_IDS.includes(chainId);

export default isDevChainId;
